<div class="container-principal">
  <div class="header-avatar">
    <div class="header-content">
      <h1>BIENVENIDA (O)</h1>
      <h2>Sistema AVATAR</h2>
      <p style="font-size: 15px !important;">Cambio de Contraseña</p>
    </div>
  </div>

  <div class="form-container" *ngIf="aprobado">
    <div class="toolbar">
      <h3>Cambio de Contraseña</h3>
    </div>

    <div class="form-content">
      <div class="instrucciones">
        <ul>
          <li>Digite una Contraseña no menor a 4 y no mayor a 10 Caracteres.</li>
          <li>Evite utilizar la misma clave que usa con la cuenta de correo institucional o personales.</li>
          <li>Se recomienda utilizar letras y números no consecutivos.</li>
        </ul>
      </div>

      <form [formGroup]="cambioClaveForm">
        <div class="form-group" *ngIf="superUsuario">
          <label for="usuario">Usuario:</label>
          <select id="usuario" formControlName="usuario" class="form-control">
            <option value="">Seleccione un usuario</option>
            <option *ngFor="let user of usuarios" [value]="user.codigo">
              {{ user.nombre }}
            </option>
          </select>
        </div>

        <div class="form-group" *ngIf="!estado">
          <label for="claveActual">Contraseña Actual</label>
          <div class="input-password">
            <input 
              [type]="mostrarPassword ? 'text' : 'password'" 
              id="claveActual" 
              formControlName="claveActual" 
              class="form-control"
              placeholder="••••••••">
            <button 
              type="button" 
              class="btn-toggle-password" 
              (click)="togglePasswordVisibility()">
              <i 
                class="mdi" 
                [ngClass]="mostrarPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'">
              </i>
            </button>
          </div>
        </div>

        <div class="form-group">
          <label for="claveNueva">Nueva Contraseña</label>
          <div class="input-password">
            <input 
              [type]="mostrarPassword ? 'text' : 'password'" 
              id="claveNueva" 
              formControlName="claveNueva" 
              class="form-control"
              placeholder="••••••••">
            <button 
              type="button" 
              class="btn-toggle-password" 
              (click)="togglePasswordVisibility()">
              <i 
                class="mdi" 
                [ngClass]="mostrarPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'">
              </i>
            </button>
          </div>
        </div>

        <div class="form-group">
          <label for="claveConfirmacion">Confirmación de Contraseña</label>
          <div class="input-password">
            <input 
              [type]="mostrarPassword ? 'text' : 'password'" 
              id="claveConfirmacion" 
              formControlName="claveConfirmacion" 
              class="form-control"
              placeholder="••••••••">
            <button 
              type="button" 
              class="btn-toggle-password" 
              (click)="togglePasswordVisibility()">
              <i 
                class="mdi" 
                [ngClass]="mostrarPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'">
              </i>
            </button>
          </div>
        </div>

        <div class="form-actions">

          <button 
            *ngIf="!superUsuario && estado" 
            type="button" 
            class="btn btn-light" 
            (click)="primeraContrasena()"
            [disabled]="procesando || cambioClaveForm.invalid">
            Cambiar Contraseña
          </button>

          <button 
            *ngIf="!superUsuario"
            type="button" 
            class="btn btn-dark" 
            (click)="regresarPrincipal()">
            Regresar a la página principal
          </button>
        </div>

        <div *ngIf="mostrarMensaje" class="mensaje-container">
          {{ mensaje }}
        </div>
      </form>
    </div>
  </div>

  <div class="mensaje-expirado" *ngIf="!aprobado">
    <p>Lo lamento, pero la página indicada ha expirado.</p>
    <a (click)="regresarPrincipal()" class="link-regresar">
      Regresar a la página principal.
    </a>
  </div>
</div>